import React, { useState } from 'react';

const faqs = [
  {
    question: 'How does AI-powered learning work at BESST?',
    answer: 'Our AI system analyzes your learning patterns, strengths, and weaknesses to create personalized study plans. It continuously adapts based on your progress and provides targeted recommendations for optimal learning outcomes.'
  },
  {
    question: 'What courses does BESST offer?',
    answer: 'We offer comprehensive courses for CUET-UG, JEE Main & Advanced, NEET, and various competitive exams. Each course includes interactive content, practice tests, and personalized learning paths.'
  },
  {
    question: 'How accurate are the progress analytics?',
    answer: 'Our analytics system provides detailed insights into your performance with high accuracy. It helps identify areas needing improvement and tracks your progress in real-time for better exam preparation.'
  },
  {
    question: 'Can I access courses on mobile devices?',
    answer: 'Yes! BESST is fully responsive and works seamlessly on all devices. You can access your courses, take tests, and track progress from your smartphone, tablet, or computer.'
  },
  {
    question: 'What payment methods are accepted?',
    answer: 'We accept all major payment methods including credit/debit cards, UPI, net banking, and popular wallets. We also offer EMI options for selected courses.'
  }
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-32 bg-gradient-to-br from-secondary-purple/10 to-dark-purple/10">
      <div className="max-w-3xl mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="section-title">Frequently Asked Questions</h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <span 
                  className={`text-2xl transition-transform duration-300 ${
                    activeIndex === index ? 'rotate-45' : ''
                  }`}
                >
                  +
                </span>
              </div>
              
              {activeIndex === index && (
                <div className="faq-answer animate-slide-down">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
